module.exports = __webpack_public_path__ + "img/appstore.d3a3be61.png";